import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setPromptOkCancelOnHome } from "../menu/menuSlice"
import { useAuth0 } from "@auth0/auth0-react";
import styles from './Wizard.module.css';
import { Page } from "../../Page"
import { selectCurrentPartyEvent, setEndDate} from "../currentPartyEvent/currentPartyEventSlice"
import { addPartyEventAsync, selectPartyEventsStatus } from "../partyEvents/partyEventsSlice";
import { useNavigate } from "react-router-dom";
import { MessageBoxAction, setMessage, setMessageBoxAction } from "../messageBoxes/messageBoxSlice";
import { sanitizeEmail } from "../../utils/emailUtils";
import { DateTimePicker } from "../../components/DateTimePicker";
import { BackButton } from "../menu/BackButton";

export function CreateEndTime() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const partyEventsStatus = useAppSelector(selectPartyEventsStatus)
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setPromptOkCancelOnHome(true))
        dispatch(setMessage('Cancel saving this event and return to the home page?'))
    })
    return (
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
           
                <DateTimePicker nullDescription="Slide toggle if you don't want to set end date or time yet" transmissionDateTime={currentPartyEvent?.end} dateDescription='What date does it end?' timeDescription='What time does it end?' dateLabel='' timeLabel = ''
                    onDateChange={(e) => {
                        dispatch(setEndDate(e ?? ''))
                    }}
                />
            </div>
                  <br></br>
                    <div className={styles.controlButtons}>
                    <button className={styles.cancelButton} onClick={()=> {
                         let msg3 = `Cancel creating this Party?`
                         dispatch(setMessage(msg3))
                          dispatch(setMessageBoxAction(MessageBoxAction.GoHome))
                            navigate('/MessageBox')
                          }}> Cancel</button>
                    <button className={styles.skipButton} onClick={async() => {
                        if (isAuthenticated && user?.email && currentPartyEvent != null) { 
                            const accessToken = await getAccessTokenSilently({ authorizationParams : {
                            }})
                            dispatch(addPartyEventAsync( { 
                                partyEvent: currentPartyEvent,
                                token: accessToken,
                                userEmail: sanitizeEmail(user?.email)
                                }))
                            if (partyEventsStatus === 'idle') {
                                navigate('/')
                            } else {
                                alert (`Not expected status '${ partyEventsStatus }'`)
                            }
                    }   
                     }}>Skip</button>

  <button className={styles.saveButton} onClick={async () => {

                            if (isAuthenticated && user?.email && currentPartyEvent != null) { 
                                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                }})
                                    dispatch(addPartyEventAsync( { 
                                        partyEvent: currentPartyEvent,
                                        token: accessToken,
                                        userEmail: sanitizeEmail(user?.email)
                                        }))
                                    if (partyEventsStatus === 'idle') {
                                        navigate('/')
                                    } else {
                                        alert (`Not expected status '${ partyEventsStatus }'`)
                                    }
                            }   
                    }}>
                        Save
                    </button>
                    </div>
        </Page>
    )
}